import { ResponseResolver, rest, RestContext, RestRequest } from "msw";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { ApiCatalog } from "@/api";
import { v3SchoolThroughTeacherMock } from "./queries.test.mock";
import type { V3SchoolThroughTeacherResponse } from "./queries.type";

export const createV3SchoolThroughTeacherQueryHandler = (
  {
    defaultData,
    status,
  }: {
    defaultData?: Partial<V3SchoolThroughTeacherResponse> | undefined;
    status?: number;
  } = {
    defaultData: v3SchoolThroughTeacherMock,
    status: 200,
  },
) => {
  const mockedResolver = jest.fn((_req, res, ctx) => {
    return res(
      ctx.json(defaultData || v3SchoolThroughTeacherMock),
      ctx.delay(100),
      ctx.status(status || 200),
    );
  }) as jest.MockedFunction<ResponseResolver<RestRequest, RestContext>>;
  const get = rest.get(
    `${MONOLITH_ORIGIN}${ApiCatalog.schoolThroughTeacher.endpoint.replace(
      "[id]",
      "me",
    )}`,
    mockedResolver,
  );
  return {
    get,
    mockedResolver,
  };
};
